import { api } from '@setplex/tria-api'
import { createEvent, sample } from 'effector'
import { model as router } from '~/core/router'
import { query } from '~/shared/routes'

// *
// * EVENTS
// *

export const initExactTvChannelPage = createEvent<{ channelId: number }>()

export const getTvChannelUrl = createEvent<{ channelId: number }>()

export const postTvRecord = createEvent<{
  channelId: number
  start: number
  stop: number
}>()

export const seeAllTvClick = createEvent<{
  id: number
  categoryName?: string
}>()

sample({
  clock: seeAllTvClick,
  fn: ({ id, categoryName }) =>
    `/content/live/categories/${id}${query({ categoryName })}`,
  target: router.navigatePush,
})

// *
// * CONNECTIONS
// *

// /content/live/:id
sample({
  clock: initExactTvChannelPage,
  target: [getTvChannelUrl],
})

sample({
  clock: initExactTvChannelPage,
  target: [api.tv.getTvChannelUrlAbortableFx],
})
